const firstLevelRoutesList = [
  {
    path: 'user/account-info',
    element: 'AccountInfo',
  },
  {
    path: 'user/security',
    element: 'Security',
  },
  {
    path: 'user/api-management',
    element: 'ApiManagement',
    pageWrapperClass: 'api-management-page-wrapper',
  },
  {
    path: 'user/sub-account',
    element: 'SubAccount',
    pageWrapperClass: 'sub-account-page-wrapper',
  },
  {
    path: 'user/settings',
    element: 'Settings',
    lazy: true,
  },
  {
    path: 'user/statement',
    element: 'Statement',
    lazy: true,
  },
  {
    path: 'user/audit',
    element: 'Audit',
    lazy: true,
    pageWrapperClass: 'por-page-wrapper',
  },
];

export default firstLevelRoutesList;

// const FirstLevelRoutes = () => {
//   return (

//     </Suspense>
//   );
// };

// export default FirstLevelRoutes;
